// src/hooks/useScrollNavigation.js
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

export const useScrollNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Handle hash scrolling when component mounts or location changes
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        scrollToElement(id);
      }, 100); // Small delay to ensure DOM is ready
    }
  }, [location]);

  const scrollToElement = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
      
      // Add highlight effect if element supports it
      if (element.classList) {
        element.classList.add("highlight");
        setTimeout(() => {
          element.classList.remove("highlight");
        }, 2000);
      }
    }
  };

  const navigateToSection = (sectionId, targetPage = '/') => {
    if (location.pathname === targetPage) {
      // Same page - just scroll
      scrollToElement(sectionId);
    } else {
      // Different page - navigate with hash
      navigate(`${targetPage}#${sectionId}`);
    }
  };

  return { navigateToSection, scrollToElement };
};